import types from "./types";
import { postData } from "../../utils/fetch-requests";

const fetchAllUsers = () => dispatch => {
  fetch("/api/user/fetch-all-users")
    .then(res => res.json())
    .then(users => {
      dispatch({
        type: types.USER_MANAGEMENT_RECEIVE_ALL_USERS,
        payload: users
      });
    });
};

const deleteUser = id => dispatch => {
  return postData("/api/user/delete-user/" + id, {}).then(res => {
    dispatch(fetchAllUsers());
    return res;
  });
};

export { fetchAllUsers, deleteUser };
